// Keep API attribute order deterministic between SSR and the browser.
export const productAttributes = (product) => (product.attributes || []).slice()
  .sort((a, b) => (Number(a.position) || 0) - (Number(b.position) || 0));

export function productDate(value, locale = 'ro', withTime = false) {
  if (!value || Number.isNaN(new Date(value).getTime())) return null;
  return new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : 'ro-RO', {
    timeZone: 'Europe/Bucharest', day: 'numeric', month: 'short', year: 'numeric',
    ...(withTime ? { hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } : {}),
  }).format(new Date(value));
}

export const purchaseStatus = (purchase, product) => {
  if (purchase.mode === 'viewOnly') return 'unavailable';
  if (purchase.mode === 'drop') return product.activeDrop ? 'drop' : 'unavailable';
  if (purchase.mode === 'auction') return 'auction';
  return purchase.availability;
};
